import { Injectable } from "@angular/core"
import { AssessmentOLD } from "../model/content"
import {
	RhythmRepeatExercise,
	RhythmRepeatExerciseAssessment,
	RhythmRepeatLessonConcept
} from "../model/lessons/rhythm-repeat"
import { AssessedTime, RhythmScore, SimpleTime } from "../model/rhythm"
import { averageBy } from "../utils/array-utils"
import { StatisticsService } from "./statistics.service"

/**
 * Work with rhythms.
 */
@Injectable()
export class RhythmService {

	constructor(public statistics: StatisticsService) {
	}

	//TIDY: move into RhythmRepeatExercise
	answerTODO(exercise: RhythmRepeatExercise, input: SimpleTime[]): AssessmentOLD {
		//compute assessment
		let assessedRhythm = this.assess(exercise, input)
		exercise.assessedBeats = assessedRhythm.beats
		exercise.overallAssessment = assessedRhythm.overall
		//assess patterns and send them to statistics
		let noteIndex = 0
		let patternIndex = 0
		//TODO let results: Result[] = []
		for (let measure of exercise.score.measures) {
			for (let pattern of measure.patterns) {
				//collect note assessments
				let assessment = 0
				for (let note of pattern.durations) {
					if (noteIndex < exercise.assessedBeats.length)
						assessment += exercise.assessedBeats[noteIndex].assessment
					noteIndex++
				}
				assessment /= pattern.durations.length
				//TODO results.push(new Result(exercise.expected[patternIndex], assessment))
				patternIndex++
			}
		}
		//TODO this.statistics.reportResults(RhythmRepeatLessonConcept.instance, results)
		return exercise.overallAssessment
	}

	/**
	 * For the given exercise, ssesses the given user input.
	 * The notes are annotated with assessments.
	 */
	assess(exercise: RhythmRepeatExercise, input: SimpleTime[]): RhythmRepeatExerciseAssessment {
		//assess exercise
		let score = exercise.score
		//we do not know the delay of the tap (TODO), so we move the whole input between
		//0 and 400 ms back (in 10 ms steps) and see what gives the best assessment. we use
		//that offset
		let bestOffsetMs = 0
		let bestAssessment = 0
		for (let offsetMs = 0; offsetMs <= 0; offsetMs += 10) { //GOON
			let offsetTime = score.msToTime(offsetMs)
			let assessedInput = input.map(beat => new AssessedTime(beat - offsetTime))
			let assessment = this.matchRhythms(exercise.score, assessedInput)
			//console.log(offsetMs + " is " + offsetTime + " , assessed " + assessment) //TEST
			if (assessment > bestAssessment) {
				bestAssessment = assessment
				bestOffsetMs = offsetMs
			}
		}
		//console.log("best offset ms " + bestOffsetMs) //TEST
		let offsetTime = score.msToTime(bestOffsetMs)
		let assessedInput = input.map(beat => new AssessedTime(beat - offsetTime))
		return {
			overall: this.matchRhythms(exercise.score, assessedInput),
			beats: assessedInput
		}
	}

	/**
	 * Tries to match the given rhythmic score to the given user input.
	 * The notes are annotated with assessments, and the overall assessment is returned.
	 */
	private matchRhythms(score: RhythmScore, inputNotes: AssessedTime[]): AssessmentOLD {
		//unmark all notes
		for (let note of score.notes.concat(inputNotes)) {
			note.assessment = null
		}
		//find best match as long as possible
		while (true) {
			let minDistance: SimpleTime = Number.MAX_VALUE
			let minScoreNoteIndex: number = null
			let minInputNoteIndex: number = null
			//test all distances between each score note and each input note
			for (let iScoreNote = 0; iScoreNote < score.notes.length; iScoreNote++) {
				let scoreNote = score.notes[iScoreNote]
				//when score note was already matched, skip it
				if (scoreNote.matched)
					continue;
				for (let iInputNote = 0; iInputNote < inputNotes.length; iInputNote++) {
					let inputNote = inputNotes[iInputNote]
					//when input note was already matched, skip it
					if (inputNote.matched)
						continue;
					let distance = Math.abs(scoreNote.time - inputNote.time)
					if (distance < minDistance) {
						//new matching candidate
						minDistance = distance
						minScoreNoteIndex = iScoreNote
						minInputNoteIndex = iInputNote
					}
				}
			}
			//if a matching was found, use it and assess it
			if (minScoreNoteIndex != null) {
				let assessment: AssessmentOLD = this.assessDistance(minDistance)
				score.notes[minScoreNoteIndex].assessment = assessment
				inputNotes[minInputNoteIndex].assessment = assessment
			}
			else {
				break; //no matching found any more
			}
		}
		//mark all unmatched notes with assessment = 0
		let allNotes = score.notes.concat(inputNotes)
		for (let note of allNotes) {
			if (!note.matched)
				note.assessment = 0
		}
		//compute overall assessment
		let overallAssessment = averageBy(allNotes, note => note.assessment)
		return overallAssessment
	}

	/**
	 * Assesses the given time distance.
	 */
	private assessDistance(distance: SimpleTime): AssessmentOLD {
		if (distance < 1/64)
			return 1
		else if (distance < 1.5/64)
			return 0.75
		else if (distance < 1/32)
			return 0.5
		else if (distance < 1/16)
			return 0.25
		else
			return 0
	}

}


// WEBPACK FOOTER //
// ./src/service/rhythm.service.ts